import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Line } from 'react-chartjs-2'
import constants from '../../../lib/constants'
import { generateChartData } from '../../../lib/chartHelpers'

class TableView extends React.Component {
  static defaultProps = {
    job: {},
    jobId: {}
  }

  static propTypes = {
    job: PropTypes.shape({})
  }

  renderValue = (val) => {
    if (val) {
      return Number(val.toFixed(2))
    } else {
      return 0
    }
  }

  render () {
    const { job } = this.props

    const chartData = generateChartData(job)

    const chartOptions = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 50
            }
          }
        ]
      }
    }

    let avgRgb = 0.0
    if (['hemoglobin', 'hemoglobin_green'].includes(job.strip_type)) {
        const rgbValues = job.rgb_values_excluding_outliers ? job.rgb_values_excluding_outliers : "[0]"
        const parsedRgbValues = JSON.parse(rgbValues)
        var avgBlankRgb = 0
        var avgBloodRgb = 0
        if (parsedRgbValues.length == 2) {
          const blankRgbValues = parsedRgbValues[0]
          const bloodRgbValues = parsedRgbValues[1]
          avgBloodRgb = (bloodRgbValues.reduce((a,b) => a + b, 0) / bloodRgbValues.length).toFixed(2)
          if (blankRgbValues.length > 0) {
            avgBlankRgb = (blankRgbValues.reduce((a,b) => a + b, 0) / blankRgbValues.length).toFixed(2)
          }
        } else {
            avgBloodRgb = (parsedRgbValues.reduce((a,b) => a + b, 0) / parsedRgbValues.length).toFixed(2)
        }
        avgRgb = [avgBlankRgb, avgBloodRgb]
    }

    return (
      <div>
        <h4> Cells Per Image </h4>
        <div style={{ marginTop: 40, marginBottom: 40, maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}>
          <Line
            data={chartData.wbcChartData}
            options={chartOptions}
          />
        </div>
        <h4> Neutrophil % Per Image </h4>
        <div style={{ marginTop: 40, marginBottom: 40, maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}>
          <Line
            data={chartData.neutrophilChartData}
            options={chartOptions}
          />
        </div>
        <h4> Neutrophil % Per Image Center </h4>
        <div style={{ marginTop: 40, marginBottom: 40, maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}>
          <Line
            data={chartData.neutrophilChartDataCenter}
            options={chartOptions}
          />
        </div>
        <h4> Neutrophil % Per Image Outer </h4>
        <div style={{ marginTop: 40, marginBottom: 40, maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}>
          <Line
            data={chartData.neutrophilChartDataOuter}
            options={chartOptions}
          />
        </div>
        <h4> Job Statistics </h4>
        <div className='table-responsive'>
          <table className='table' style={{ marginBottom: 40, marginTop: 30 }}>
            <thead>
              <tr>
                <th scope='col'>Parameter</th>
                <th scope='col'>True</th>
                <th scope='col'>Predicted</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope='row'>WBC</th>
                <td>{this.renderValue(job.predictedWBCCount)} K/µL</td>
                <td>{this.renderValue(job.wbc_count)} K/µL</td>
              </tr>
              <tr>
                <th scope='row'>Flag</th>
                <td> - </td>
                <td>{job.flag ? constants.FLAG_MESSAGES[job.flag] : 'No Flag'}</td>
              </tr>
              <tr>
                <th scope='row'>Error Message</th>
                <td> - </td>
                <td>{job.error_message ? job.error_message : 'No Error'}</td>
              </tr>
              <tr>
                <th scope='row'>Neutrophils</th>
                <td>{this.renderValue(job.totalNeutrophils / job.totalDifferentiableCells * 100)} %</td>
                <td>{this.renderValue(job.neutrophils)} %</td>
              </tr>
              <tr>
                <th scope='row'>Neutrophils Center</th>
                <td>{this.renderValue(100 * _.sum(job.neutrophilsPerImageCenter) / (_.sum(job.neutrophilsPerImageCenter) + _.sum(job.lymphocytesPerImageCenter)))} %</td>
                <td>{this.renderValue(job.neutrophils)} %</td>
              </tr>
              <tr>
                <th scope='row'>Neutrophils Outer</th>
                <td>{this.renderValue(100 * _.sum(job.neutrophilsPerImageOuter) / (_.sum(job.neutrophilsPerImageOuter) + _.sum(job.lymphocytesPerImageOuter)))} %</td>
                <td>{this.renderValue(job.neutrophils)} %</td>
              </tr>
              <tr>
                <th scope='row'>WBC CV%</th>
                <td>{this.renderValue(job.wbcCV)} %</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Neutrophil STD Dev</th>
                <td>{this.renderValue(job.neutrophilStdDev)} %</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Neutrophil STD Dev Center</th>
                <td>{this.renderValue(job.neutrophilStdDevCenter)} %</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Platelet Concentration</th>
                <td>{job.platelet_concentration} K/µL</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Hemoglobin Count</th>
                <td>{job.hb_count} g/dL </td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Hemoglobin Counts</th>
                <td>{job.hb_counts} g/dL </td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Hemoglobin Blank Reference Value</th>
                <td>{job.blank_reference}</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Hb Average All RGB Values</th>
                <td>{job.rgb_values}</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Hb Average RGB Values (Outliers Removed)</th>
                <td>{job.rgb_values_excluding_outliers}</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Hb AVG</th>
                <td>{avgRgb.toString()}</td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Device String</th>
                <td><a href={`/device/${job.device_string}`}>{job.device_string}</a></td>
                <td></td>
              </tr>
              <tr>
                <th scope='row'>Created At</th>
                <td>{new Date(job.created_at).toLocaleString()}</td>
                <td></td>
              </tr>
              <tr>
                <th scope='row'>Updated At</th>
                <td>{new Date(job.updated_at).toLocaleString()}</td>
                <td></td>
              </tr>
              <tr>
                <th scope='row'>Log File</th>
                <td>
                  <a
                    href={`${constants.STORAGE_URL}${constants.DEVICE_LOGS_BUCKET}/${job.device_string}/${job.job_id}/?project=${constants.PROJECT}`}
                    target='_blank'
                  >
                    Log File
                  </a>
                </td>
                <td>-</td>
              </tr>
              <tr>
                <th scope='row'>Pullback Video</th>
                <td>
                  <a
                    href={`https://console.cloud.google.com/storage/browser/_details/athelas-pullback-videos/${job.device_string}/${job.job_id}_pullback_video.mp4;tab=live_object?project=${constants.PROJECT}`}
                    target='_blank'
                  >
                    Pullback video
                  </a>
                </td>
                <td>-</td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default TableView



// WEBPACK FOOTER //
// ./src/routes/Images/components/TableView.js